import { Card, pxToRem, Spacing, Text } from "@ottatech/design";
import React from "react";

import { Link } from "components/Link";

export function CookiePolicy(): React.ReactElement {
  return (
    <Card style={{ marginTop: pxToRem(20) }}>
      <Spacing>
        <Text bold size={1} align="left">
          Cookie policy
        </Text>
        <Text align="left">
          We use cookies to give you the best experience on our website.{" "}
          <Link
            to="https://otta.com/privacy-policy/cookie-policy"
            underline={false}
          >
            You can find more details in our cookie policy.
          </Link>
        </Text>
      </Spacing>
    </Card>
  );
}
